import { api, type Invite, type Uuid } from "@shared/api";
import { inviteLink } from "@shared/lib/jump";

/** Неделя — как ссылка Discord по умолчанию. */
const WEEK_HOURS = 168;
/** Чужую или почти истёкшую ссылку не берём: друг должен успеть по ней прийти. */
const SPARE_MS = 24 * 3_600_000;

/**
 * Ссылка, которую отправляют, — своя живая на тот же канал (без предела, не на
 * исходе) берётся готовой, иначе заводится новая на неделю. Каждое
 * приглашение не должно оставлять в списке приглашений ещё одну строку.
 */
export async function ownLink(serverId: Uuid, meId: Uuid, channelId: Uuid | null): Promise<Invite> {
  // Список приглашений видят не все, кто вправе приглашать: отказ — просто новая ссылка.
  const listed = await api.invites.list(serverId).then((value) => value.items, () => []);
  const fresh = listed.find(
    (invite) =>
      invite.creator_id === meId &&
      invite.max_uses === null &&
      (invite.channel_id ?? null) === channelId &&
      (invite.expires === null || Date.parse(invite.expires) - Date.now() > SPARE_MS),
  );
  return (
    fresh ??
    api.invites.create(serverId, { max_uses: null, expires_in_hours: WEEK_HOURS, channel_id: channelId })
  );
}

/** Ссылка уходит человеку в личку — как в Discord. */
export async function sendLink(userId: Uuid, code: string): Promise<void> {
  const direct = await api.directs.open(userId);
  await api.messages.post(direct.channel_id, inviteLink(code));
}
